<template>
  <div class="basic_wrap" style="padding-bottom: 40px;">
    <bsHeader
      :title="$t('utils.gmzq')"
      @backurl="$router.back()"
    />
    
    <!-- 剧集信息卡片 -->
    <div class="episode-card">
      <img
        :src="episode.img"
        alt="img"
        class="episode-cover"
      >
	  <div
	    class="episode-title"
	    style="color: #fff;font-size: 14px;line-height: 32px;text-align: center;"
	  >
	    {{ $t('utils.bflzst') }}
	  </div>
      <div
        ref="charts"
        class="proCharts"
      />
      <div class="episode-details">
        <div
          class="episode-title"
          style="color: #fff;"
        >
          {{ dramaTitle }} · {{ episode.epLabel }}
        </div>
        <div class="episode-meta">
          <span>★ {{ dramaRating }}</span>
          <span>👁 {{ dramaViews }}</span>
          <span class="level-badge">{{ $t('utils.dqdj') }}{{ currentLevelname }}</span>
        </div>
    
        <div class="price-info">
          <div class="info-row">
            <span class="info-label">{{ $t('utils.lunlog30') }}</span>
            <span class="info-value blue">{{ requiredLevelname }}</span>
          </div>
						
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('index.amount') }}</span>
            <span class="info-value gold">{{ common.currency_symbol_basic() }}{{ price }}</span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('invest.income') }}</span>
            <span
              class="info-value green"
              style="color: #22c55e;"
            >
              {{ common.currency_symbol_basic() }}{{ item.days }} / {{ $t('index.day') }}
            </span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span
              v-if="item.type==1"
              class="info-label"
            >{{ $t('index.dailyRate') }}</span>
            <span
              v-else
              class="info-label"
            >{{ $t('index.rate') }}</span>
							
            <span class="info-value">{{ profitRatio }}%</span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('invest.cycle') }}</span>
            <span class="info-value">{{ item.day+(item.type==3?$t('index.hour'):$t('index.day')) }}</span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('invest.type') }}</span>
            <span class="info-value">{{ $t('index.method'+item.type) }}</span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('withdraw.fundBalance') }}</span>
            <span class="info-value gold">{{ common.currency_symbol_basic() }} {{ item.balance }}</span>
          </div>
          <div class="divider" />
          <div class="info-row">
            <span class="info-label">{{ $t('utils.goodszong') }}</span>
            <span class="info-value gold">{{ common.currency_symbol_basic() }}{{ item.zong }}</span>
          </div>
        </div>
    
        <button
          v-if="currentLevel<requiredLevel"
          class="buy-btn"
          :disabled="true"
          @click="handleBuyClick"
        >
          {{ $t('utils.djbz') }}
        </button>
        <button
          v-else
          class="buy-btn"
          :disabled="false"
          @click="handleBuyClick"
        >
          {{ $t('utils.lunlog29') }}
        </button>
        <div
          v-if="currentLevel<requiredLevel"
          class="level-hint"
        >
          {{ $t('utils.dqdj') }}:{{ currentLevelname }}，{{ $t('utils.xyzddj') }}{{ requiredLevelname }} 
        </div>
      </div>
    </div>
    
    <!-- 确认购买弹窗 -->
    <div
      v-if="showModal"
      class="modal-overlay"
      @click.self="showModal = false"
    >
      <div class="modal-sheet">
        <h3 style="color:#fff">
          {{ $t('utils.qrgmbq') }}
        </h3>
        <div class="modal-info">
          <div class="modal-row">
            <span class="modal-label">{{ $t('utils.faxian') }}</span>
            <span
              class="modal-value"
              style="color: #fff;"
            >{{ dramaTitle }} {{ episode.epLabel }}</span>
          </div>
          <div class="modal-row">
            <span class="modal-label">{{ $t('index.amount') }}</span>
            <span class="modal-value ">{{ common.currency_symbol_basic() }}{{ price }}</span>
          </div>
          <div class="modal-row">
            <span class="modal-label">{{ $t('invest.income') }}</span>
            <span
              class="modal-value green"
              style="color: #22c55e;"
            >{{ common.currency_symbol_basic() }}{{ item.days }} / {{ $t('index.day') }}</span>
          </div>
          <div class="modal-row">
            <span
              v-if="item.type==1"
              class="modal-label"
            >{{ $t('index.dailyRate') }}</span>
            <span
              v-else
              class="modal-label"
            >{{ $t('index.rate') }}</span>
            <span class="modal-value">{{ profitRatio }}%</span>
          </div>
          <div class="modal-row">
            <span class="modal-label">{{ $t('invest.cycle') }}</span>
            <span class="modal-value">{{ item.day+(item.type==3?$t('index.hour'):$t('index.day')) }}</span>
          </div>
						
          <div class="modal-row">
            <span class="modal-label">{{ $t('invest.type') }}</span>
            <span class="modal-value">{{ $t('index.method'+item.type) }}</span>
          </div>
						
          <div class="modal-row">
            <span class="modal-label">{{ $t('utils.goodszong') }}</span>
            <span class="modal-value ">{{ common.currency_symbol_basic() }}{{ item.zong }}</span>
          </div>
						
          <div class="modal-row">
            <span class="modal-label">{{ $t('utils.lunlog30') }}</span>
            <span class="modal-value blue">{{ requiredLevelname }}</span>
          </div>
          <div class="modal-row">
            <span class="modal-label">{{ $t('withdraw.fundBalance') }}</span>
            <span class="modal-value blue">{{ common.currency_symbol_basic() }} {{ item.balance }}</span>
          </div>
        </div>
        <button
          class="confirm-btn"
          @click="submit()"
        >
          {{ $t('utils.qrgmbq') }}
        </button>
        <div
          class="cancel-link"
          @click="showModal = false"
        >
          {{ $t('utils.code7') }}
        </div>
      </div>
	  
    </div>
    
    <div
      class="toast"
      :class="{ show: toastVisible }"
    >
      {{ toastMsg }}
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import * as echarts from 'echarts';
	import {
		Icon,
		Popup,
		Field,
		Cell,
		CellGroup
	} from 'vant';
	Vue.use(Icon).use(Popup).use(Field).use(Cell).use(CellGroup);
	export default {
		name: "",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				item: {
					min: 0,
					type: 1,
					rate: 0,
					day: 0
				},
				user: [],
				money: "",
				income: 0,
				showPopup: false,
				loading: false,
				dramaTitle: '',
				dramaRating: '',
				dramaViews: '',
				episode: {
					
				},
				price: '',
				profitRatio: '',
				cycleDays: '',
				principalReturn: '',
				settlementMethod: '',
				currentLevel: '',        // 当前用户等级 (模拟)
				currentLevelname:'',
				requiredLevel: '',       // 购买所需最低等级
				requiredLevelname: '', 
				item:[],
				showModal: false,
				toastVisible: false,
				toastMsg: '',
				toastTimer: null,
				chart: null,
				chartResizeHandler: null
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#0F6EFF');
				plus.navigator.setStatusBarStyle('light');
			}
			this.$parent.footer('user', false);
			
		},
		mounted() {
			this.start();
		},
		beforeDestroy() {
			if (this.chartResizeHandler) {
				window.removeEventListener('resize', this.chartResizeHandler);
			}
			if (this.chart) {
				this.chart.dispose();
			}
		},
		methods: {
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(r => {
					this.item=r.data.item;
					this.dramaTitle = r.data.item.title;
					this.dramaRating = r.data.item.rating;
					this.dramaViews = r.data.item.bofang;
					this.episode.epLabel = r.data.item.episodes;
					this.episode.img = r.data.item.img;
					this.price = r.data.item.newmax;
					this.profitRatio = r.data.item.rate;
					this.cycleDays = r.data.item.day;
					this.principalReturn = r.data.item.fan;
					this.requiredLevelname= r.data.item.level_name;
					this.requiredLevel= r.data.item.mid;
					this.currentLevelname= r.data.user.level_name;
					this.currentLevel= r.data.user.mid;
					this.item.balance= r.data.user.balance;
					this.user= r.data.user;
					this.canBuy();
					this.item = r.data.item;
					
					this.change();
					this.mycharts(this.item.k_x,this.item.k_y_12m);
				})
			}, estimatedProfit() {
                    const p = parseFloat(this.price);
                    const ratio = parseFloat(this.profitRatio) / 100;
                    const days = parseInt(this.cycleDays);
                    const profit = p * ratio * days / 365;
                    return profit.toFixed(2);
                },
                canBuy() {
                    return this.currentLevel >= this.requiredLevel;
                },
			showToast(msg) {
			                    if (this.toastTimer) clearTimeout(this.toastTimer);
			                    this.toastMsg = msg;
			                    this.toastVisible = true;
			                    this.toastTimer = setTimeout(() => {
			                        this.toastVisible = false;
			                    }, 1500);
			                },
			                handleBuyClick() {
			                    if (!this.canBuy) {
			                        this.showToast('您当前会员等级不支持购买此产品');
			                        return;
			                    }
			                    this.showModal = true;
			                },
			                confirmPurchase() {
			                    this.showModal = false;
			                    this.showToast('购买成功！版权分红已生效');
			                },
			change() {
				// if (this.item.type == 1) {
				// 	this.income = this.common.precision_basic(this.item.min * this.item.rate * this.item.day / 100);
				// } else {
				// 	this.income = this.common.precision_basic(this.item.min * this.item.rate / 100);
				// }
				this.income = this.common.precision_basic(this.item.min * this.item.rate * this.item.day / 100);
			},
			submit() {
				if (this.loading) return false;
				if (!this.user.login) {
					this.$toast(this.$t('invest.loginFirst'));
					return false;
				}
				if (this.user.limit) {
					var times = this.item.num;
					if (this.item.num >= 2) times = 2;
					this.$toast(this.$t('invest.investNum') + this.item.num + this.$t('utils.times' + times));
					return false;
				}
				if (this.user.balance-this.item.min<0) {
					this.$toast(this.$t('invest.moneyNotEnough'));
					return false;
				}
				if (this.user.mid<this.item.mid) {
					this.$toast(this.$t('utils.lunlog32'));
					return false;
				}
				if (this.user.limit_today) {
					this.$toast(this.$t('invest.investNumEmpty'));
					return false;
				}
				this.loading = true;
				Fetch('/user/invest', {
					id: this.item.id
				}).then(r => {
					if(r.code=='218'){
						this.$toast(this.$t(r.info));return false;
					}else{
						this.$router.replace('/invest/record');
					}
					
				})

			},
				mycharts(k_x,k_y) {
							let myChart = echarts.init(this.$refs.charts, "macarons");
							let leng1=k_x.lenght;
							myChart.setOption({
								 tooltip: {
								    trigger: 'axis',
									confine:true,
								    position: function (pt) {
								      return [pt[0], '10%'];
								    }
								  },
								  xAxis: {
								    type: 'category',
								    boundaryGap: false,
								    data: k_y
								  },
								  yAxis: {
								    type: 'value',
								    // boundaryGap: [0, '100%'],
									// splitNumber:7
								  },
								  grid:[{
									  top :'15px'
								  }],
								  dataZoom: [
								    {
								      type: 'inside',
								      start: leng1-6,
								      end: leng1
								    },
								    {
								      start: leng1-6,
								      end: leng1
								    }
								  ],
								  series: [
								    {
								      name: '',
								      type: 'line',
								      symbol: 'none',
								      sampling: 'lttb',
								      itemStyle: {
								        color: 'rgb(255, 70, 131)'
								      },
								      areaStyle: {
								        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								          {
								            offset: 0,
								            color: '#a0a0b0'
								          },
								          {
								            offset: 1,
								            color: 'hsla(0,0%,100%,.03)'
								          }
								        ])
								      },
								      data: k_x
								    }
								  ]
								
							});
							//图表自适应
							window.addEventListener("resize", function() {
								myChart.resize() // myChart 是实例对象
							})
						}
		}
	};
</script>

<style lang="less" scoped>
	.proCharts {
		margin-bottom: 10px;
		padding-top:0px;
		height:268px;
	}

	.basic_wrap {
		position: relative;
		padding-bottom: 100px;
		height: 100vh;
		background: #000000;
	}
	.back-header {
	            display: flex;
	            align-items: center;
	            gap: 12px;
	            margin-bottom: 20px;
	        }
	        .back-btn {
	            width: 36px;
	            height: 36px;
	            border-radius: 50%;
	            background: var(--bg-card);
	            border: 1px solid var(--border);
	            display: flex;
	            align-items: center;
	            justify-content: center;
	            cursor: pointer;
	            color: #fff;
	            font-size: 18px;
	        }
	        .page-title {
	            font-size: 20px;
	            font-weight: 800;
	            letter-spacing: -0.4px;
	        }
	
	        .episode-card {
	            background: var(--bg-card);
	            border-radius: var(--radius-lg);
	            overflow: hidden;
	            border: 1px solid var(--border);
	            margin-bottom: 20px;
	        }
	        .episode-cover {
	            width: 100%;
	            aspect-ratio: 16/9;
	            object-fit: cover;
	            display: block;
	        }
	        .episode-details {
	            padding: 16px;
	        }
	        .episode-title {
	            font-size: 18px;
	            font-weight: 700;
	            margin-bottom: 6px;
	        }
	        .episode-meta {
	            font-size: 13px;
	            color: var(--text-secondary);
	            margin-bottom: 12px;
	            display: flex;
	            align-items: center;
	            gap: 10px;
	        }
	        .episode-meta span {
	            display: flex;
	            align-items: center;
	            gap: 4px;
	        }
	
	        .price-info {
	            display: flex;
	            flex-direction: column;
	            gap: 10px;
	            margin-top: 8px;
	            padding: 12px;
	            background: rgba(255, 255, 255, 0.03);
	            border-radius: var(--radius-md);
	        }
	        .info-row {
	            display: flex;
	            justify-content: space-between;
	            align-items: center;
	            font-size: 14px;
	        }
	        .info-label {
				font-size: 12px;
				width: 40%;
	            color: var(--text-secondary);
	        }
	        .info-value {
				text-align:right;
	            font-size: 12px;
	            width: 60%;
	            color: #fff;
	        }
	        .info-value.gold {
	            color: var(--accent-gold);
	        }
	        .info-value.green {
	            color: var(--accent-green);
	        }
	        .info-value.blue {
	            color: var(--accent-blue);
	        }
	        .divider {
	            width: 100%;
	            height: 1px;
	            background: var(--border);
	            margin: 2px 0;
	        }
	        .level-badge {
	            display: inline-block;
	            background: rgba(59, 130, 246, 0.15);
	            color: var(--accent-blue);
	            padding: 2px 10px;
	            border-radius: 12px;
	            font-size: 12px;
	            font-weight: 600;
	        }
	        .buy-btn {
	            width: 100%;
	            margin-top: 16px;
	            padding: 14px;
	            border-radius: 24px;
	            background: var(--accent);
	            color: #fff;
	            font-size: 15px;
	            font-weight: 700;
	            border: none;
	            cursor: pointer;
	            transition: all 0.2s;
	            letter-spacing: 0.02em;
	        }
	        .buy-btn:disabled {
	            background: #333;
	            color: #888;
	            cursor: not-allowed;
	        }
	        .buy-btn:not(:disabled):active {
	            transform: scale(0.97);
	            opacity: 0.9;
	        }
	        .level-hint {
	            font-size: 12px;
	            color: var(--text-muted);
	            text-align: center;
	            margin-top: 8px;
	        }
	        .level-hint.warn {
	            color: var(--accent-gold);
	        }
	
	        /* 弹窗 */
	        .modal-overlay {
	            position: fixed;
	            inset: 0;
	            background: rgba(0, 0, 0, 0.7);
	            backdrop-filter: blur(6px);
	            display: flex;
	            align-items: flex-end;
	            justify-content: center;
	            z-index: 100;
	            transition: opacity 0.3s;
	        }
	        .modal-sheet {
	            width: 100%;
	            max-width: 430px;
	            background: var(--bg-secondary);
	            border-radius: var(--radius-xl) var(--radius-xl) 0 0;
	            padding: 24px 20px calc(20px + var(--safe-bottom));
	            border-top: 1px solid var(--border);
	            animation: slideUp 0.3s ease;
	        }
	        @keyframes slideUp {
	            from { transform: translateY(100%); }
	            to { transform: translateY(0); }
	        }
	        .modal-sheet h3 {
	            font-size: 20px;
	            font-weight: 800;
	            margin-bottom: 16px;
	            text-align: center;
	        }
	        .modal-info {
	            display: flex;
	            flex-direction: column;
	            gap: 12px;
	            margin-bottom: 20px;
	        }
	        .modal-row {
	            display: flex;
	            justify-content: space-between;
	            align-items: center;
	            font-size: 14px;
	            padding: 0 4px;
	        }
	        .modal-label {
				font-size: 12px;
				width: 40%;
	            color: var(--text-secondary);
	        }
	        .modal-value {
	            font-size: 12px;
	            width: 60%;
				text-align: right;
	            color: #fff;
	        }
	        .modal-value.highlight {
	            color: var(--accent-gold);
	            font-size: 18px;
	        }
	        .modal-value.green {
	            color: var(--accent-green);
	        }
	        .modal-value.blue {
	            color: var(--accent-blue);
	        }
	        .confirm-btn {
	            width: 100%;
	            padding: 14px;
	            border-radius: 24px;
	            background: var(--accent);
	            color: #fff;
	            font-size: 15px;
	            font-weight: 700;
	            border: none;
	            cursor: pointer;
	            transition: all 0.2s;
	        }
	        .confirm-btn:active {
	            transform: scale(0.97);
	            opacity: 0.9;
	        }
	        .cancel-link {
	            display: block;
	            text-align: center;
	            margin-top: 12px;
	            font-size: 13px;
	            color: var(--text-muted);
	            cursor: pointer;
	        }
	
	        .toast {
	            position: fixed;
	            top: 50%;
	            left: 50%;
	            transform: translate(-50%, -50%) scale(0.85);
	            background: rgba(28, 28, 38, 0.96);
	            color: #fff;
	            padding: 14px 28px;
	            border-radius: 28px;
	            font-size: 14px;
	            font-weight: 600;
	            z-index: 999;
	            pointer-events: none;
	            opacity: 0;
	            transition: all 0.35s;
	        }
	        .toast.show {
	            opacity: 1;
	            transform: translate(-50%, -50%) scale(1);
	        }
	:root {
	            --bg-primary: #000000;
	            --bg-secondary: #0a0a0d;
	            --bg-card: #141418;
	            --accent: #e50914;
	            --accent-gold: #fbbf24;
	            --accent-green: #22c55e;
	            --accent-blue: #3b82f6;
	            --text-primary: #f5f5f5;
	            --text-secondary: #a1a1aa;
	            --text-muted: #6b6b75;
	            --border: rgba(255, 255, 255, 0.08);
	            --radius-xl: 20px;
	            --radius-lg: 16px;
	            --radius-md: 12px;
	            --radius-sm: 8px;
	            --safe-bottom: env(safe-area-inset-bottom, 16px);
	            --shadow-card: 0 2px 12px rgba(0, 0, 0, 0.5);
	        }
	.proCharts {
			margin-bottom: 10px;
			padding-top:15px;
			height:268px;
		}
</style>
